var r = /* @__PURE__ */ ((o) => (o.Download = "download", o))(r || {});
export {
  r as GAEventCategory
};
//# sourceMappingURL=googleAnalytics.js.map
